var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.text)?_c('div',{staticClass:"notice-box",style:({padding: _vm.padding})},[_c('van-notice-bar',{attrs:{"left-icon":"volume-o","text":_vm.text,"background":_vm.background,"color":"#F44336"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }